module.exports = THREE;